export enum Layouts {
  Simple,
  Full,
}
